import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { bookingApi } from '../utils/bookingApi';
import { startPreview } from '../utils/preview';
import './booking/booking-shared.css';

const WHAT_YOU_SEE = {
  parent: 'A parent with one child at the club.',
  adult: 'An adult member who trains themselves.',
  gymnast: 'A 16-year-old gymnast with their own account.',
  child: 'The simple pages a child sees after signing in with a code.',
  coach: 'A coach, without admin pages.',
  welfare: 'A welfare officer, including welfare reports.',
};

export default function PreviewAs() {
  const { user } = useAuth();
  const [roles, setRoles] = useState([]);
  const [error, setError] = useState(null);
  const [starting, setStarting] = useState(null);

  useEffect(() => {
    if (!user?.isDeveloper) return;
    bookingApi.getPreviewRoles()
      .then(res => setRoles(res.data))
      .catch(() => setError('Could not load the preview accounts.'));
  }, [user?.isDeveloper]);

  if (!user?.isDeveloper) return <Navigate to="/dashboard" replace />;

  const preview = async (role) => {
    setStarting(role.key);
    setError(null);
    try {
      const res = await bookingApi.startPreview(role.key);
      startPreview(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not start the preview.');
      setStarting(null);
    }
  };

  return (
    <div className="bk-page bk-page--md">
      <h2>Preview as</h2>
      <p className="bk-muted" style={{ marginTop: 0 }}>
        See the app as someone else, using a made-up account in your club. These accounts don't
        appear in member lists, registers or reports, and nothing can be changed while you're
        previewing. A banner at the top takes you back to your own account.
      </p>
      {error && <p className="bk-error">{error}</p>}
      {roles.map(role => (
        <div key={role.key} className="bk-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem' }}>
          <div>
            <strong>{role.label}</strong>
            <p className="bk-muted" style={{ margin: '0.2rem 0 0', fontSize: '0.88rem' }}>{WHAT_YOU_SEE[role.key]}</p>
          </div>
          <button className="bk-btn bk-btn--primary bk-btn--sm" disabled={Boolean(starting)} onClick={() => preview(role)}>
            {starting === role.key ? 'Opening…' : 'Preview'}
          </button>
        </div>
      ))}
    </div>
  );
}
